import { ajaxPost } from '../../ajax'

const LeaguesPlugin = store => next => action => {
  switch (action.type) {
  }
  return next(action)
}

export default LeaguesPlugin
